angular.module('cvsApp').controller('onlinePayementController', ['$scope','$window','title','$location','PAGE_PATH','accountBalanceService','getSpecialtyWCMContentService', 'msgManagerService', 'webTrendsService','cvsAppData','validateDeepLinkModel', function($scope,$window,title,$location, PAGE_PATH, ABS, GSWCMCS, MMS, WTS,CAD, VDM) {
	'use strict';
	$scope.title= title;
	var aBal = this;
	var payHistLink='';
	CAD.setSelect('OP');
	
	if(CAD.isOPTabLocked()){
		WTS.webTrendsUtag("OBJ",{ page_name:'SRX: QuickReg: Error: Locked'});
		if(CAD.contextInfo && CAD.contextInfo.memberOnlineStatus.toUpperCase()==='ACTIVE') {
			$window.top.location = cvsUtility.getRedirecttoLogin("OP");
		}
	}

	if(CAD.contextInfo  && cvsUtility.queryMap.tokenId){
		if(CAD.contextInfo.contextInformation.toUpperCase()==="TAP"){
			//TAP and signed in
			WTS.webTrendsUtag("OBJ",{page_name:'SRX: QuickReg: TrackRx: Balance'                       
	         });
		} else {
			WTS.webTrendsUtag("OBJ",{page_name:'SRX: QuickReg: Pay: Balance'                       
	          });
	    }

		if(cvsUtility.queryMap.FromQuickRegistration){
			//logged in, AR and QR
			 if(CAD.contextInfo.contextInformation.toUpperCase()==="TAP") {
				WTS.webTrendsUtag("OBJ",{page_name:'SRX: QuickReg: TrackRx: RegComplete: Balance'});
			} else {
				WTS.webTrendsUtag("OBJ",{page_name:'SRX: QuickReg: Payment: RegComplete: Balance'});
	    }
				}
		}

     if(CAD.contextInfo && !cvsUtility.queryMap.tokenId && CAD.contextInfo.memberOnlineStatus.toUpperCase()==="INACTIVE" && !CAD.isOPTabLocked()){	    
	    if(CAD.contextInfo.contextInformation.toUpperCase()==="RFR" ){
	    		  WTS.webTrendsUtag("OBJ",{page_name:'SRX: QuickReg: Online Payment: IDConf'});
	    } else {
	    	  WTS.webTrendsUtag("OBJ",{page_name:'SRX: QuickReg: Online Payment: IDConfirmed' });
		}	
	}

	var error = MMS.errorMsg('SERVER_ERROR');

	if(cvsUtility.queryMap.tokenId){
		aBal.rfrnonregistered = true;
	}else{		
		aBal.rfrnonregistered = false;
	}

	GSWCMCS.getContent('OnlinePayment',onConentSuccess);
	
	if(!CAD.isOPTabLocked()){
		if(!aBal.rfrnonregistered){			
			ABS.getAccBal(onSuccess, VDM.header.tokenID);
		}else{
			ABS.getAccBal(onSuccess);
		}
		
	}
	else {
		aBal.onQRLinkClick = function ($event) {
			var target = angular.element($event.target);
			if(target.prop('tagName').toUpperCase() == 'A') {
				$location.path(PAGE_PATH.CONF_ID);
				return false;
			}
		};
	}

	function onConentSuccess(data) {
		if (data.getError() === '') {
			aBal.content = data.getContent().online_payment;
		}
		else {
			var defaultContent = {
				op_locked_tab: 'Before you can make payments online, you must confirm your identity.<br/><br/><a>Return to Quick Registration</a> to complete this short process.'
			};
			aBal.content = cvsUtility.addHardcodingTag(defaultContent);
		}
	}

	function onSuccess(data){
		if(data.SERVER_ERROR){
			aBal.ERROR = data;
			return;
		}

		aBal.showErrBal = data.getError() !== "" ? true:false;
		aBal.acBalError = data.getError().statusDesc ? error : '';

		aBal.showBal = data.getError() === "" ? true:false;
		aBal.showView = data.showView();
		
		var accountBal = data.getAcBal();
		//aBal.viewError = error;
		aBal.acBalance = accountBal;
		if(accountBal && accountBal > 0){
			aBal.isPosBal = true;
 			aBal.paymentLink = "Make a payment";
			aBal.paymentLinkTarget = createChannelUrl('makePayment');
			aBal.historyLinkTarget = createChannelUrl('paymentHistory');
			
		}else{
			aBal.isPosBal = false;
			aBal.paymentLink = "Manage repeating payments";
			aBal.paymentLinkTarget = createChannelUrl('recurringPayment');
			aBal.historyLinkTarget = createChannelUrl('paymentHistory');

		}

	aBal.makePayment = function(data){
			 if(cvsUtility.queryMap.FromQuickRegistration){	
				 //Trigger same tagging on Make a Payment and View Payment History
				 if((CAD.contextInfo.contextInformation==="TAP" && CAD.contextInfo.memberOnlineStatus.toUpperCase()==="ACTIVE")){
						WTS.webTrendsUtag("LINK",{
                     		page_name:'SRX: QuickReg: TrackRx: RegComplete: Pay link'
	             		});
					} else {
			    WTS.webTrendsUtag("LINK",{
                           scenario_name:'SRX: QuickReg: Unregistered',
 	                       scenario_step:'SRX: OnlinePay: MakePayment',
						   page_name:'SRX: QuickReg: Payment: RegComplete: Pay link'
                 });
					}
					if(data==="makePayment"){
						$window.open(aBal.paymentLinkTarget,'_blank');
					} else {
						$window.open(aBal.historyLinkTarget,'_blank');
					}
			 }else{
			 	if(data==="makePayment"){
			 		if(cvsUtility.queryMap.tokenId){
						 WTS.webTrendsUtag("LINK",{
                     	scenario_name:'SRX: QuickReg: Registered',
 	                 	scenario_step:'SRX: ReadyRefill: Make Payment',
							page_name:'SRX: QuickReg: Pay: Make Payment'  
                 	 });	
					} else if(CAD.contextInfo.memberOnlineStatus.toUpperCase()==="INACTIVE"){
					 WTS.webTrendsUtag("LINK",{
                     	scenario_name:'SRX: QuickReg: Unregistered',
 	                 	scenario_step:'SRX: OnlinePay: Balance',
							page_name:'SRX: QuickReg: Payment: IDConfirmed: Pay link'                
                 	 });
                    }
                    
                    $window.open(aBal.paymentLinkTarget,'_blank');
			 	}
			 	else{
					 WTS.webTrendsUtag("LINK",{
                     	scenario_name:'SRX: QuickReg: Registered',
 	                 	scenario_step:'SRX: ReadyRefill: View Pay History',
							page_name:'SRX: QuickReg: Pay: View Pay History'
                 	 });	
                    $window.open(aBal.historyLinkTarget,'_blank');

			 	}
			 }

	};	
	}

}]);
